import KatalLogger, { Level, LoggerConfig } from '@amzn/katal-logger';
import { getBrowserInfo, getPlatform, getTimezone } from './clientEnvUtils';

export let logger: KatalLogger;

/**
 * Configure and initialize KatalLogger
 * @param userAlias - User's alias for attribution
 * @param displayName - User's display name
 */
export const configureKatalLogger = (userAlias: string, displayName: string): void => {
  const logThreshold = Level.DEBUG;
  const { name: browserName, version: browserVersion } = getBrowserInfo();
  const katalLoggerConfig: LoggerConfig = {
    url: 'https://logger-alpha.verity.device.finance.amazon.dev/v1/log',
    logThreshold: logThreshold,
    maxLogLineSize: 10000,
    logToConsole: true,
    // Context fields appear as JSON keys in CloudWatch Logs entries.
    // New fields are supported — they appear automatically in Logs Insights queries.
    context: {
      app: 'verity-website',
      env: 'alpha',
      logType: 'general',
      userAlias: userAlias,
      givenName: displayName,
      timezone: getTimezone(),
      browser: browserName,
      browserVersion: browserVersion,
      platform: getPlatform(),
    },
  };

  // Create a custom logger that doesn't rely on crypto
  logger = new KatalLogger(katalLoggerConfig);

  // Don't add performance listener to avoid crypto dependency
  // logger.addPerformanceListener();
};

/**
 * Log user authentication entry
 */
export const entryLog = async (): Promise<void> => {
  try {
    await logger.info(`User authenticated successfully!`, {
      logType: 'entry_log',
    });
  } catch (error) {
    console.warn('Error logging entry:', error);
  }
};
